import { render, staticRenderFns } from "./StaticContentType.vue?vue&type=template&id=3bc1f121"
import script from "./StaticContentType.vue?vue&type=script&lang=js"
export * from "./StaticContentType.vue?vue&type=script&lang=js"
import style0 from "./StaticContentType.vue?vue&type=style&index=0&id=3bc1f121&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports